export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14192.c88bbf2f.jpg";